import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavMenu } from './NavMenu';
import { Footer } from './Footer';

export const Layout = () => {
  return (
    <div>
      {/* <NavMenu /> */}
      {/* <Container fluid> */}
      <Outlet />
      {/* </Container> */}
      {/* <Footer /> */}
    </div>
  );
}
